import { render, staticRenderFns } from "./gallerySlider.vue?vue&type=template&id=5d6360ca&scoped=true"
import script from "./gallerySlider.vue?vue&type=script&lang=js"
export * from "./gallerySlider.vue?vue&type=script&lang=js"
import style0 from "./gallerySlider.vue?vue&type=style&index=0&id=5d6360ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6360ca",
  null
  
)

export default component.exports